module.exports = __webpack_public_path__ + "static/img/grow6.2adaa7bf.png";